import { useClassName } from '@/styles/AffiliateItem';
import { ClassNameProp, PropsFromComponent, PropsFromSubcomponents } from '@/types/component';
import { GenericComponentFactory } from 'base/components/GenericComponent';
import { AffiliateProductVariants } from '.';
import { AffiliateItemProductImageComponent } from './AffiliateItem.Product.Image';

type Extras = {
  size?: ClassNameProp<AffiliateProductVariants>;
  variant?: ClassNameProp<AffiliateProductVariants>;
};

export type AffiliateItemProps = PropsFromComponent<typeof AffiliateItem>;
export type AffiliateItemSubcomponentProps = PropsFromSubcomponents<typeof AffiliateItem>;

const Component = GenericComponentFactory({ useClassName });

export const AffiliateItem = Object.assign(Component({ styles: { key: '' } })<Extras>, {
  Headline: Component<'h2' | 'h3'>({ as: 'h2', styles: { key: 'headline' } })<Extras>,
  Description: Component({ as: 'p', styles: { key: 'description' } })<Extras>,
  Counter: Component({ as: 'span', styles: { key: 'counter' } })<Extras>,
  Subtitle: Component({ as: 'span', styles: { key: 'subtitle' } })<Extras>,
  Group: Component({ styles: { key: 'group' } })<Extras>,
  Product: Object.assign(Component({ styles: { key: 'product' } })<Extras>, {
    Image: AffiliateItemProductImageComponent,
    Headline: Component<'h3' | 'h4' | 'h5'>({ as: 'h5', styles: { key: 'product_headline' } })<Extras>,
    Caption: Component({ as: 'span', styles: { key: 'product_caption' } })<Extras>,
    Vendor: Component({ as: 'span', styles: { key: 'product_vendor' } })<Extras>,
  }),
});
